import { render, staticRenderFns } from "./_tabelFilterColumn.vue?vue&type=template&id=fba308e6&scoped=true&"
import script from "./_tabelFilterColumn.vue?vue&type=script&lang=js&"
export * from "./_tabelFilterColumn.vue?vue&type=script&lang=js&"
import style0 from "./_tabelFilterColumn.vue?vue&type=style&index=0&id=fba308e6&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fba308e6",
  null
  
)

export default component.exports